import React, { useState } from 'react';
import './ThesisDetail.css'; // Tu peux réutiliser ce CSS
import { ArrowLeft, Crown } from 'lucide-react'; // Ajout de Crown pour le style Premium

function ThesisDetailPremium({ thesis, onBack }) {
  const [openSections, setOpenSections] = useState({
    notice: true,
    problematique: true
  });

  if (!thesis) return null;

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="thesis-detail-page">
      <div className="glass-card thesis-detail-card" style={{ borderTop: '4px solid #ffc107' }}>
        
        <div className="detail-content-wrapper">
          {/* --- CÔTÉ GAUCHE: Couverture --- */}
          <div className="detail-image-container">
            <img 
              src={thesis.Couverture_R ? `https://api.memofacdz.com${thesis.Couverture_R}` : "/placeholder-cover.jpg"} 
              alt={thesis.intitule_R || "Couverture Premium"} 
              className="thesis-cover-large" 
            />
          </div>

          {/* --- CÔTÉ DROIT: Informations --- */}
          <div className="detail-info-container">
            {/* On utilise intitule_R car intitule_M a été retiré */}
            <h2 className="detail-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Crown size={24} color="#ffc107" />
              {thesis.intitule_R || "Titre Premium"}
            </h2>
            <p className="detail-author">Auteur : {thesis.Ecrivain}</p>

            {/* Accordéon 1: Notice Bibliographique */}
            <div className="accordion-item">
              <button 
                className={`accordion-button ${openSections.notice ? 'active' : ''}`}
                onClick={() => toggleSection('notice')}
              >
                Notice Bibliographique
                <span className={`arrow ${openSections.notice ? 'rotate' : ''}`}>▼</span>
              </button>
              
              <div className={`accordion-grid-wrapper ${openSections.notice ? 'open' : ''}`}>
                <div className="accordion-inner-content">
                  
                  <div className="info-row">
                    <span className="info-label">Intitulé Roman:</span>
                    <span className="info-value">{thesis.intitule_R || "Non spécifié"}</span>
                  </div>
                  
                  <div className="info-row">
                    <span className="info-label">Auteur :</span>
                    <span className="info-value">{thesis.Ecrivain}</span>
                  </div>
                  
                  {/* On utilise resume_R (Abstract) car resume_M a été retiré */}
                  <div className="info-row vertical">
                    <span className="info-label">Résumé Roman:</span>
                    <div className="long-text">
                        {thesis.resume_R || "Aucun résumé (Abstract) disponible pour ce document."}
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>

            {/* Accordéon 2: Structure & Recherche */}
            <div className="accordion-item">
              <button 
                className={`accordion-button ${openSections.problematique ? 'active' : ''}`}
                onClick={() => toggleSection('problematique')}
              >
                Axes de recherche Possibles
                <span className={`arrow ${openSections.problematique ? 'rotate' : ''}`}>▼</span>
              </button>
              
              <div className={`accordion-grid-wrapper ${openSections.problematique ? 'open' : ''}`}>
                <div className="accordion-inner-content">
                  
                  <div className="info-row vertical">
                    <span className="info-label">Axes / Chapitres :</span>
                    <div className="long-text axe-text">
                        {thesis.Axes && thesis.Axes.length > 0 ? (
                          <ul className="axes-list">
                            {thesis.Axes.map((axe, index) => (
                              <li key={index} style={{marginBottom: '8px'}}>{axe}</li>
                            ))}
                          </ul>
                        ) : "Aucun axe spécifié pour ce document."}
                    </div>
                  </div>

                  {/* La section Mots-clés a été complètement retirée selon ta demande */}
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- FOOTER --- */}
        <div className="detail-footer">
          <button 
            className="cta-button return-button" 
            onClick={onBack}
            style={{ backgroundColor: '#1f2937', color: 'white' }} // Style sobre pour contraster avec le doré
          >
            <ArrowLeft size={16} /> Retour à la liste Premium
          </button>
        </div>
      </div>
    </div>
  );
}

export default ThesisDetailPremium;